/**
 * ReportsHarvestInspectionNumberOfInspections
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    numberOfInspections?: ?number;
}

export class ReportsHarvestInspectionNumberOfInspections extends React.PureComponent<Props> {
    render() {
        const { numberOfInspections } = this.props;
        if (!numberOfInspections && numberOfInspections !== 0) return null;
        return numberOfInspections;
    }
}

const mapStateToProps = createStructuredSelector({
    numberOfInspections: makeSelectReportsHarvestInspectionValue(
        'numberOfInspections'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionNumberOfInspections
);
